export default "__VITE_ASSET__DixONkkR__"